import script from "./DialogModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogModal.vue?vue&type=script&setup=true&lang=ts"

export default script